import React from 'react';
import { Tooltip } from '@patternfly/react-core';
import { TInsightsChangeEvent } from '../../api/types/insights-change-event';

/**
 * Muted single-line notice that the underlying data changed after the current
 * insights were generated. Deliberately quiet — it is a thread annotation, not
 * a chat message. `subject` is interpolated mid-sentence, so it stays a bare
 * lowercase noun.
 */
const InsightsChangeNotice: React.FC<{
	event: TInsightsChangeEvent;
	subject: 'dashboard' | 'chart';
}> = ({ event, subject }) => (
	<Tooltip
		content={event.detail}
		position="left"
	>
		<div
			className="insights-change-notice"
			tabIndex={0}
		>
			Content on {subject} changed · {event.summary}
		</div>
	</Tooltip>
);

export default InsightsChangeNotice;
